import { eventQBus } from "../types/EventQBus";
import NextBestAction from "../nextBestAction/NextBestAction.svelte";
import NextBestActionDeprecated from "../nextBestAction/NextBestActionDeprecated.svelte";
import NextBestActionDesktop from "../nextBestAction/NextBestActionDesktop.svelte";
import FacetValueTagsDeprecated from "../facetvaluetags/FacetValueTagsDeprecated.svelte";
import FacetValueTags from "../facetvaluetags/FacetValueTags.svelte";
import FilterBanner from "../filterBanner/FilterBanner.svelte";
import DesktopSorting from "../sorting/DesktopSorting.svelte";
import ConfigurableFacet from "../facet/ConfigurableFacet.svelte";
import type { ConfigurableFilterOptions } from "@otto-ec/heureka-components/filter";
import { Assets, setActiveConfiguration } from "@otto-ec/heureka-components/filter";
import type { Component } from "svelte";
import { mount, unmount } from "svelte";
import type { Facet } from "@otto-ec/heureka-components/facet";
import { clear, mapElements, notEmpty } from "../util/Utils";
import { isDesktop, isMobile } from "../util/Breakpoint";
import { CustomRangeInput } from "./slider/CustomRangeInput";
import { events } from "../events";
import { getActiveVariation, initExperiments, isActiveVariation } from "../experiment/Experiments";
import FilterHarmonized from "../filter/FilterHarmonized.svelte";
import { FilterTitle } from "./FilterTitle";
import { FilterAccordion } from "./FilterAccordion";
import { isActive } from "../toggle/Toggle";
import { NextBestActionComponent, resetNBAScrollTracking } from "../nextBestAction/NextBestActionComponent";
import { refinementBar } from "../filtersheet/Selectors";

initExperiments(); /*                                                                 */
const shoeSizeExperiment = isActiveVariation("e3663", "E3663B");
/*                                                                                                            */
const config: Record<string, ConfigurableFilterOptions> = {
  color: {
    filterConfig: {
      default: {
        facetConfig: {
          type: "simple",
          facetValueGroupConfig: {
            type: "grid",
            facetValueConfig: {
              type: "chip",
              facetValueLabelConfig: {
                type: "color",
                titleSize: "100",
              },
            },
          },
        },
      },
      sheetFirstLevel: {
        facetConfig: {
          type: "simple",
          facetValueGroupConfig: {
            type: "overflowBox",
            facetValueConfig: {
              type: "chip",
              facetValueLabelConfig: {
                type: "color",
                titleSize: "75",
              },
            },
          },
        },
      },
      sheetSecondLevel: {
        facetConfig: {
          type: "simple",
          facetValueGroupConfig: {
            type: "queueBox",
            facetValueConfig: {
              type: "chip",
              facetValueLabelConfig: {
                type: "color",
                titleSize: "75",
              },
            },
          },
        },
      },
    },
  },
  rating: {
    filterConfig: {
      default: {
        facetConfig: {
          type: "simple",
          facetValueGroupConfig: {
            facetValueConfig: {
              type: "radio",
              facetValueLabelConfig: {
                type: "rating",
              },
            },
          },
        },
      },
    },
  },
  retailprice: {
    filterConfig: {
      default: {
        facetConfig: {
          type: "interval",
          facetValueGroupConfig: {
            type: "grid",
            gridCellMinSize: "79",
            containsRanges: true,
            facetValueConfig: {
              type: "singleSelectRange",
              facetValueLabelConfig: {
                type: "text",
                size: "75",
                showCount: false,
              },
            },
          },
        },
      },
      sheetFirstLevel: {
        facetConfig: {
          type: "interval",
          facetValueGroupConfig: {
            type: "grid",
            gridCellMinSize: "100",
            containsRanges: true,
            facetValueConfig: {
              type: "singleSelectRange",
              facetValueLabelConfig: {
                type: "text",
                size: "75",
                showCount: false,
              },
            },
          },
        },
      },
      sheetSecondLevel: {
        facetConfig: {
          type: "interval",
          facetValueGroupConfig: {
            type: "grid",
            gridCellMinSize: "100",
            containsRanges: true,
            facetValueConfig: {
              type: "range",
              facetValueLabelConfig: {
                type: "text",
                size: "75",
                fitContent: true,
                showCount: false,
              },
            },
          },
        },
      },
    },
  },
  interval: {
    filterConfig: {
      default: {
        facetConfig: {
          type: "interval",
          facetValueGroupConfig: {
            type: "grid",
            gridCellMinSize: "90",
            containsRanges: true,
            facetValueConfig: {
              type: "range",
              facetValueLabelConfig: {
                type: "text",
                fitContent: true,
                size: "75",
                showCount: false,
              },
            },
          },
        },
      },
      sheetFirstLevel: {
        facetConfig: {
          type: "interval",
          facetValueGroupConfig: {
            type: "grid",
            gridCellMinSize: "90",
            facetValueConfig: {
              type: "range",
              facetValueLabelConfig: {
                type: "text",
                fitContent: true,
                size: "75",
                showCount: false,
              },
            },
          },
        },
      },
      sheetSecondLevel: {
        facetConfig: {
          type: "interval",
          facetValueGroupConfig: {
            type: "overflowBox",
            containsRanges: true,
            facetValueConfig: {
              type: "range",
              facetValueLabelConfig: {
                type: "text",
                fitContent: true,
                size: "75",
                showCount: false,
              },
            },
          },
        },
      },
    },
  },
  switch: {
    filterConfig: {
      default: {
        facetConfig: {
          type: "simple",
          facetValueGroupConfig: {
            facetValueConfig: {
              type: "toggle",
              facetValueLabelConfig: {
                type: "text",
              },
            },
          },
        },
      },
      sheetFirstLevel: {
        facetConfig: {
          type: "simple",
          facetValueGroupConfig: {
            facetValueConfig: {
              type: "toggle",
              facetValueLabelConfig: {
                type: "text",
              },
            },
          },
        },
      },
    },
  },
  radio: {
    filterConfig: {
      default: {
        facetConfig: {
          type: "simple",
          facetValueGroupConfig: {
            facetValueConfig: {
              type: "radio",
              facetValueLabelConfig: {
                type: "text",
              },
            },
          },
        },
      },
    },
  },
  chip: {
    filterConfig: {
      default: {
        facetConfig: {
          type: "simple",
          facetValueGroupConfig: {
            type: "grid",
            facetValueConfig: {
              type: "chip",
              facetValueLabelConfig: {
                type: "text",
                fitContent: true,
                size: "75",
                showCount: false,
              },
            },
          },
        },
      },
      sheetFirstLevel: {
        facetConfig: {
          type: "simple",
          facetValueGroupConfig: {
            type: "queueBox",
            facetValueConfig: {
              type: "chip",
              facetValueLabelConfig: {
                type: "text",
                fitContent: true,
                size: "75",
                showCount: false,
              },
            },
          },
        },
      },
      sheetSecondLevel: {
        facetConfig: {
          type: "simple",
          facetValueGroupConfig: {
            type: "grid",
            facetValueConfig: {
              type: "chip",
              facetValueLabelConfig: {
                type: "text",
                fitContent: true,
                size: "75",
                showCount: false,
              },
            },
          },
        },
      },
    },
  },
  shoesize: {
    filterConfig: {
      default: {
        facetConfig: {
          type: "simple",
          facetValueGroupConfig: {
            type: "grid",
            facetValueConfig: {
              type: "chip",
              facetValueLabelConfig: {
                type: "text",
                fitContent: true,
                size: "75",
                showCount: false,
              },
            },
          },
        },
      },
      sheetFirstLevel: {
        facetConfig: {
          type: "simple",
          facetValueGroupConfig: {
            type: "overflowBox",
            facetValueConfig: {
              type: "chip",
              facetValueLabelConfig: {
                type: "text",
                fitContent: true,
                size: "75",
                showCount: false,
              },
            },
          },
        },
      },
      sheetSecondLevel: {
        facetConfig: {
          type: shoeSizeExperiment ? "saveable" : "simple",
          facetValueGroupConfig: {
            type: "grid",
            facetValueConfig: {
              type: "chip",
              facetValueLabelConfig: {
                type: "text",
                fitContent: true,
                size: "75",
                showCount: false,
              },
            },
          },
        },
      },
    },
  },
  ottoLogo: {
    filterConfig: {
      default: {
        facetConfig: {
          type: "simple",
          facetValueGroupConfig: {
            facetValueConfig: {
              type: "toggle",
              facetValueLabelConfig: {
                type: "textWithLogo",
                size: "100",
                logo: "otto",
              },
            },
          },
        },
      },
    },
  },
  default: {
    filterConfig: {
      default: {
        facetConfig: {
          facetValueGroupConfig: {
            facetValueConfig: {
              facetValueLabelConfig: {
                type: "text",
              },
            },
          },
        },
      },
      sheetFirstLevel: {
        facetConfig: {
          facetValueGroupConfig: {
            type: "queueBox",
            facetValueConfig: {
              type: "chip",
              facetValueLabelConfig: {
                type: "text",
                showCount: false,
                size: "75",
              },
            },
          },
        },
      },
    },
  },
};

export function initializeConfigurableFacet(fragment: DocumentFragment) {
  /*                                                                                                       */
  setActiveConfiguration(isMobile() ? "sheetFirstLevel" : "default");
  mapElements(".ts_heureka_svelteFacet", (elem) => createFacet(elem, fragment), fragment)
    .filter(notEmpty)
    .map(CustomRangeInput.init);
}

const sortedExperiment: boolean = isActiveVariation("e3815", "Sorted");

/*                                                                 */
/*                                                                                        */
/*                                                                                              */
/*                                                                                                             */
const mountedConfigurableFacets = new Map<string, ReturnType<typeof mount>>();

function createFacet(elem: HTMLElement, fragment?: DocumentFragment) {
  const parentElement = elem.parentElement as HTMLElement;
  const { serialized, facetVisibility, filterTitleMode, hasNbaValues } = elem.dataset;
  const facet: Facet = JSON.parse(serialized);
  if (isMobile() && isActiveVariation("e3676", "NBFToggle") && facet.id.toLowerCase() === "retailer_otto") {
    /*                                                                 */
    FilterTitle.filterId(facet.filterId, fragment)?.elem.remove();
    FilterAccordion.filterId(facet.filterId, fragment)?.accordion.remove();
    return;
  }
  const filterConfig =
    config[facet.id.toLowerCase()] ||
    (isActiveVariation("e3663", "E3663B") &&
      ["shoesizeeuv2", "shoesizeukv2", "shoesizeusv2"].includes(facet.id) &&
      config["shoesize"]) ||
    (facet.selectionType === "range" && config["interval"]) ||
    (isActiveVariation("e3676", "NBFToggle") &&
      isDesktop() &&
      facet.id.toLowerCase() === "retailer_otto" &&
      config["ottoLogo"]) ||
    (facet.selectionType === "switch" && config["switch"]) ||
    (facet.selectionType === "radio" && config["radio"]) ||
    (facet.selectionType === "chip" && config["chip"]) ||
    (facet.selectionType === "rating" && config["rating"]) ||
    (facet.selectionType === "colorTile" && config["color"]) ||
    config["default"];

  /*                                                                           */
  if (sortedExperiment) {
    const existingInstance = mountedConfigurableFacets.get(facet.id);
    if (existingInstance) {
      unmount(existingInstance);
    }
  }

  const instance = mount(ConfigurableFacet, {
    target: parentElement,
    props: {
      data: {
        ...facet,
        showTitle: elem.dataset.showTitle === "true",
        useSlider: elem.dataset.mayHideSlider !== "true",
        parentId: `find_filter_${facet.filterId}`,
      },
      filterTitleMode: filterTitleMode,
      visibility: facetVisibility,
      hasNbaValues: hasNbaValues,
      ...filterConfig,
    },
  });
  if (sortedExperiment) {
    mountedConfigurableFacets.set(facet.id, instance);
  }
  elem.remove();
  return parentElement;
}

export function initializeNextBestActionComponentDeprecated(
  componentType: Component<NextBestActionDeprecated> | Component<NextBestActionDesktop>,
  isDesktopNBA: boolean = false,
) {
  const initializationClass = isDesktopNBA
    ? "ts_heureka_svelteDesktopNextBestAction"
    : "ts_heureka_svelteNextBestAction";
  const useNewModelForPriceRanges = getActiveVariation("e3474", "StatusQuo") !== "StatusQuo";

  mapElements(`.${initializationClass}`, (elem) => {
    const parentElement = elem.parentElement as HTMLElement;
    const { serialized } = elem.dataset;

    /*                                                         */
    const parsedData = JSON.parse(serialized);

    /*                                                                                                             */
    /*                                                                    */
    if (parsedData.values && !useNewModelForPriceRanges && isMobile()) {
      parsedData.values.forEach((value) => {
        if (value.name === "preis-in-eur") {
          value.referencedFacetValueId = "facetValue_retailprice_value";
        }
      });
    }
    mount(componentType, {
      target: parentElement,
      props: {
        ...parsedData,
        containsOnlyNbaValues: elem.dataset.containsOnlyNbaValues === "true",
        withExpander: isDesktopNBA,
      },
    });
    elem.remove();
    return parentElement;
  });
}

export function initializeNextBestActionComponent(
  componentType: Component<NextBestAction> | Component<NextBestActionDesktop>,
  refinementBar: HTMLElement | undefined,
  isDesktopNBA: boolean = false,
) {
  if (refinementBar) {
    if (isDesktopNBA) {
      /*                                                                                    */
      const refinementBarPlaceholder = document.getElementById("heureka_refinementBar__placeholder");
      if (
        refinementBarPlaceholder &&
        !refinementBarPlaceholder.classList.contains("heureka_refinementBar__placeholder--hidden")
      ) {
        refinementBarPlaceholder.classList.add("heureka_refinementBar__placeholder--hidden");
      }
    }
    const initializationClass = isDesktopNBA
      ? "ts_heureka_svelteDesktopNextBestAction"
      : "ts_heureka_svelteNextBestAction";
    const useNewModelForPriceRanges = getActiveVariation("e3474", "StatusQuo") !== "StatusQuo";

    mapElements(`.${initializationClass}`, (elem) => {
      const parentElement = elem.parentElement as HTMLElement;
      const { serialized } = elem.dataset;

      /*                                                         */
      const parsedData = JSON.parse(serialized);

      /*                                                                                                             */
      /*                                                                    */
      if (parsedData.values && !useNewModelForPriceRanges && isMobile()) {
        parsedData.values.forEach((value) => {
          if (value.name === "preis-in-eur") {
            value.referencedFacetValueId = "facetValue_retailprice_value";
          }
        });
      }
      mount(componentType, {
        target: refinementBar,
        props: {
          ...parsedData,
          containsOnlyNbaValues: elem.dataset.containsOnlyNbaValues === "true",
          withExpander: isDesktopNBA,
        },
      });
      elem.remove();
      return parentElement;
    });
  }
}

export function initializeFacetValueTagsComponentDeprecated() {
  /*                                                                                    */
  const refinementBarPlaceholder = document.getElementById("heureka_refinementBar__placeholder");
  if (
    refinementBarPlaceholder &&
    !refinementBarPlaceholder.classList.contains("heureka_refinementBar__placeholder--hidden")
  ) {
    refinementBarPlaceholder.classList.add("heureka_refinementBar__placeholder--hidden");
  }

  mapElements(".ts_heureka_svelteFacetValueTags", (elem) => {
    const parentElement = elem.parentElement as HTMLElement;
    const { serialized } = elem.dataset;

    const parsedData = JSON.parse(serialized);

    mount(FacetValueTagsDeprecated, {
      target: parentElement,
      props: {
        ...parsedData,
      },
    });
    elem.remove();
    return parentElement;
  });
}

export function initializeFacetValueTagsComponent(refinementBar: HTMLElement | undefined) {
  /*                                                                                    */
  if (refinementBar) {
    const refinementBarPlaceholder = document.getElementById("heureka_refinementBar__placeholder");
    if (
      refinementBarPlaceholder &&
      !refinementBarPlaceholder.classList.contains("heureka_refinementBar__placeholder--hidden")
    ) {
      refinementBarPlaceholder.classList.add("heureka_refinementBar__placeholder--hidden");
    }

    mapElements(".ts_heureka_svelteFacetValueTags", (elem) => {
      const parentElement = elem.parentElement as HTMLElement;
      const { serialized } = elem.dataset;

      const parsedData = JSON.parse(serialized);

      mount(FacetValueTags, {
        target: refinementBar,
        props: {
          ...parsedData,
        },
      });
      elem.remove();
      return parentElement;
    });
  }
}

export function initializeQuickFilterHarmonizedComponent() {
  /*                              */
  if (document.getElementById("harmonized-filter-btn")) {
    return;
  }
  const cassandraPlaceholder = document.getElementById("cassandra-floating-btn");
  if (cassandraPlaceholder) {
    mount(FilterHarmonized, {
      target: cassandraPlaceholder, /*                                         */
      props: { hideAboveRefinementBar: isActive("HEUREKA_2193_HIDE_FLOATING_FILTER_ABOVE_REFINEMENT_BAR") },
    });
  }
}

function initializeAssets() {
  mount(Assets, {
    target: document.body,
  });
}

export function initializeDesktopSortingComponent() {
  mapElements(".ts_heureka_svelteDesktopSorting", (elem) => {
    const parentElement = elem.parentElement as HTMLElement;
    const { serialized } = elem.dataset;

    mount(DesktopSorting, {
      target: parentElement,
      props: {
        ...JSON.parse(serialized),
      },
    });
    elem.remove();
    return parentElement;
  });
}

export function initializeFilterBannerComponent() {
  mapElements(".ts_heureka_svelteFilterBanner", (elem) => {
    const parentElement = elem.parentElement as HTMLElement;
    const { serialized } = elem.dataset;

    mount(FilterBanner, {
      target: parentElement,
      props: {
        ...JSON.parse(serialized),
      },
    });
    elem.remove();
    return parentElement;
  });
}

export default function registerSvelteComponentInitialization() {
  if (isActive("HEUREKA_2167_MIGRATE_FILTER_BANNER_TO_SVELTE")) {
    events.onFilterSectionLoaded(initializeFilterBannerComponent);
  }
  if (isActive("HEUREKA_2167_MIGRATE_DESKTOP_SORTING_TO_SVELTE")) {
    events.onFilterSectionLoaded(initializeDesktopSortingComponent);
  }
  if (isMobile()) {
    if (isActive("HEUREKA_2117_MOUNT_NBF_DIRECTLY_IN_REFINEMENT_BAR")) {
      events.onFilterSectionLoaded(() => {
        const refBar = refinementBar();
        clear(refBar);
        if (NextBestActionComponent.couldBeVisible()) {
          resetNBAScrollTracking();
        }
        initializeNextBestActionComponent(NextBestAction, refBar);
      });
    } else {
      events.onFilterSectionLoaded(() => initializeNextBestActionComponentDeprecated(NextBestActionDeprecated));
    }
    events.onFilterSectionLoaded(initializeQuickFilterHarmonizedComponent);
  } else {
    if (!isActiveVariation("e3676", "StatusQuo")) {
      events.onFilterSectionLoaded(() => {
        const refBar = refinementBar();
        clear(refBar);
        initializeNextBestActionComponent(NextBestActionDesktop, refBar, true);
      });
    } else {
      if (isActive("HEUREKA_2117_MOUNT_NBF_DIRECTLY_IN_REFINEMENT_BAR")) {
        events.onFilterSectionLoaded(() => {
          const refBar = refinementBar();
          clear(refBar);
          initializeFacetValueTagsComponent(refBar);
        });
      } else {
        events.onFilterSectionLoaded(initializeFacetValueTagsComponentDeprecated);
      }
    }
  }
  eventQBus.once("heureka.filterSection.loaded", initializeAssets);
}
